<div class="row">
	<div class="col-sm-12 grey">
		<div class="milestones">
			<a
				class="btn btn-sm btn-primary float-right"
				(click)="edit()"
				*ngIf="project?.isDraft && !usercompanyid">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>
		</div>
	</div>
	<div
		class="col-sm-12 loading"
		*ngIf="loading">
		<div class="grey-bg">
			<i class="fa fa-circle-notch fa-spin fa-2x fa-fw"></i>
		</div>
	</div>
	<div class="col-sm-12">
		<div class="milestones">
			<ul class="content-list">
				<li
					*ngFor="let milestone of milestones"
					class="milestone card">
					<div class="row">
						<div class="col-5">
							<div class="append-bottom-5">
								<strong>{{milestone.name}}</strong>
							</div>
							<div class="text-date mb-1 mt-1">
								{{milestone.milestonedate | date:"dd/MM/yyyy"}}
							</div>

							<div>
								<div
									class="status-box"
									*ngIf="milestone.isExpired">
									<span class="badge badge-danger">
										{{ 'labels.expired' | translate | titlecase}}
									</span>

								</div>
							</div>
						</div>
						<div class="col-5">
							<div class="progress-container">
								<div
									class="progress-bar"
									style="width:{{milestone.completeDeliverablesPerc * 100}}%"></div>
							</div>
							<span class="detail">
								<b>{{milestone.totalDeliverables}}</b>
								deliverable -
								<b>{{milestone.uncompleteDeliverables}}</b>
								da caricare -
								<b>
									{{milestone.completeDeliverablesPerc | percent}}
								</b>
							</span>
						</div>
						<div class="icon-buttons col-2">

							<a
								(click)="edit(milestone.id)"
								class="link">
								<i
									container="body"
									ngbTooltip="{{'labels.edit' | translate}}"
									class="feather icon-edit"
									*ngIf="project?.isDraft && !usercompanyid"></i>
							</a>
							<a
								(click)="delete(milestone, $event)"
								class="link">
								<i
									container="body"
									ngbTooltip="{{'labels.delete' | translate}}"
									class="feather icon-trash"
									*ngIf="project?.isDraft && !usercompanyid"></i>
							</a>

						</div>

					</div>
				</li>
				<li
					class="milestone card"
					*ngIf="!milestones.length && !loading">
					<div class="row">
						<div class="col-12 text-center">
							<div class="append-bottom-5">
								<strong>{{'labels.none-milestone' | translate}}</strong>
							</div>

						</div>
					</div>
				</li>
			</ul>
		</div>

	</div>

</div>
